import { Directive, HostListener, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { IAlertTypes } from '@tablesready/frontend-alerts-bar';

@Directive({ selector: '[copy-clipboard]' })
export class CopyClipboardDirective {
  @Input('copy-clipboard') payload: string;

  constructor(
    private readonly alertsService: AlertsService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onClick(event: MouseEvent | TouchEvent): void {
    event.preventDefault();
    if (!this.payload) {
      return;
    }

    let listener = (e: ClipboardEvent) => {
      let clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', this.payload.toString());
      e.preventDefault();
    };

    try {
      this.document.addEventListener('copy', listener, false);
      this.document.execCommand('copy');
      this.document.removeEventListener('copy', listener, false);
      this.alertsService.add({
        type: IAlertTypes.success,
        heading: 'Copied:',
        body: 'Copied to clipboard!'
      });
    } catch (err) {
      this.alertsService.add({
        type: IAlertTypes.danger,
        heading: 'Error:',
        body: err
      });
    }
  }
}
